import { useState, useEffect, useRef, type RefObject } from 'react';

/**
 * @param options
 * @returns
 */
export default function usein(
  options?: IntersectionObserverInit
): [RefObject<HTMLDivElement>, boolean] {
  const [inView, setInView] = useState<boolean>(false);
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setInView(entry.isIntersecting);
    }, options);

    const currentRef = elementRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options]);

  return [elementRef, inView];
}